import React, { PureComponent } from 'react'
import { string } from 'prop-types'
import { Text } from 'components'

import './Tip.css'

export class Tip extends PureComponent {
    static propTypes = {
        text: string.isRequired,
        top: string,
        left: string,
        right: string,
        bottom: string,
        cursor: string
    }

    render() {
        const { className, text, top, left, right, bottom, cursor } = this.props

        return (
            <div className={['Tip', className]} cursor={cursor} style={{ top, left, right, bottom }}>
                <Text>{text}</Text>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Tour/Tip/Tip.js